import { render, staticRenderFns } from "./detailSeo.vue?vue&type=template&id=2cca2a34"
import script from "./detailSeo.vue?vue&type=script&lang=js"
export * from "./detailSeo.vue?vue&type=script&lang=js"
import style0 from "./detailSeo.vue?vue&type=style&index=0&id=2cca2a34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports